define(
    'C3.ShoppingExtensions.ViewInventory.Model',
    [
        'SCModel',
        'Utils'
    ],
    function(SCModelComponent, Utils){
        'use strict';

        var SCModel = SCModelComponent.SCModel;

        function ViewInventorySCModel() {
            SCModel.call(this);

            // Define properties of the model.
            this.urlRoot = function() {
                Utils.getAbsoluteUrl(
                    getExtensionAssetsPath(
                        "services/ViewInventory.Service.ss"
                    )
                )
            }
        }

        ViewInventorySCModel.prototype = Object.create(SCModel.prototype);

        ViewInventorySCModel.prototype.constructor = ViewInventorySCModel;

        // Return the AMD constructor.
        return ViewInventorySCModel;
    }
);
